import { DwAttributeType, DwContextDefinition, DwContextRepositoryService, DwControlType, DwCustomContextBase, DwCustomContextDefinition, 
         DwExpressionAttribute, DwExpressionCompareType, DwQuery, DwQueryHelper, DwSecurityTopics, DwSecurityUserService,
         DwOrmDataService, DwOrmDataServiceToken, DwMetaDataService, DwMetaDataServiceToken, DwLookupInfo, 
         DwCacheService} from '@devwareapps/devware-cap';
import { AppMetaDataItemNames, AppMetaDataLookups, DwUserEntity, FlightSchoolOrganizationEntity } from '../../../meta-data/app-meta-data.service';
import { Inject, Injectable } from '@angular/core';
import { SchoolRepositoryService } from '../services/school-repository.service';
import { tap } from 'rxjs/operators';

export const SchoolFeatureContext = 'SchoolFeatureContext';
@DwCustomContextDefinition({
    keyName: SchoolFeatureContext,
    display: 'School Features',
    isGlobal: true,
})
@Injectable()
export class SchoolFeatureContextService extends DwCustomContextBase {

    constructor(private dwSecurityUserService: DwSecurityUserService,
        private dwCacheService: DwCacheService,
        @Inject(DwOrmDataServiceToken) private dwOrmDataService: DwOrmDataService,
        @Inject(DwMetaDataServiceToken) private dwMetaDataService: DwMetaDataService,
        private schoolRepositoryService: SchoolRepositoryService
        ) {
        super();
    }

    setupContextDefinition(contextDef: DwContextDefinition) {
        contextDef.getCustomContextFunction = (context) => this.getCustomContext(context);
        //contextDef.loadContext = (context) => this.getCustomContext(context);

        contextDef.cacheInvalidationTopics = [DwSecurityTopics.SECURITY_CHANGED];

        contextDef.cacheInvalidationTopics.push(DwOrmDataService.ORM_EVENT_TOPICS.ItemChangedTopic(AppMetaDataItemNames.Subscription));
        contextDef.cacheInvalidationTopics.push(DwOrmDataService.ORM_EVENT_TOPICS.ItemChangedTopic(AppMetaDataItemNames.FlightSchool));
        contextDef.cacheInvalidationTopics.push(DwOrmDataService.ORM_EVENT_TOPICS.ItemChangedTopic(AppMetaDataItemNames.FlightSchoolOrganization));
        
        contextDef.data = {}; // Show that data is loaded so it will call getCustomContextFunction

        contextDef.attributes = [];
        contextDef.noCache = true;

        this.addProperty(contextDef.attributes, "FlightSchoolOrganizationId", "Flight School Org Id", DwAttributeType.Integer, DwControlType.NumericTextBox);
        this.addProperty(contextDef.attributes, "FlightSchoolName", "Flight School Name", DwAttributeType.Text, DwControlType.Textbox);
        this.addProperty(contextDef.attributes, "FlightSchoolId", "Flight School", DwAttributeType.Integer, DwControlType.DropDownList, AppMetaDataLookups.FlightSchoolAllItems);
        this.addProperty(contextDef.attributes, "ForceSchoolPaymentParty", "Force School Payment Party", DwAttributeType.YesNo, DwControlType.YesNoDropDown);
        this.addProperty(contextDef.attributes, "PilexosBookingCostPaymentPartyId", "Booking Cost Payment Party", DwAttributeType.Integer, DwControlType.DropDownList, AppMetaDataLookups.CheckRideRequestPaymentPartyAllItems);
        this.addProperty(contextDef.attributes, "FlightSchoolStatusId", "Status", DwAttributeType.Integer, DwControlType.DropDownList, AppMetaDataLookups.FlightSchoolStatusAllItems);
        this.addProperty(contextDef.attributes, "OriginalOwnerUserId", "Owner User", DwAttributeType.Integer,  DwControlType.DropDownList, AppMetaDataLookups.UserAllItems);

        this.addProperty(contextDef.attributes, "FlightSchoolCertificateNumber", "Flight School Certificate Number", DwAttributeType.YesNo, DwControlType.Checkbox);
        this.addProperty(contextDef.attributes, "FlightSchoolTypeId", "Flight School Type", DwAttributeType.Integer, DwControlType.DropDownList, AppMetaDataLookups.FlightSchoolTypeAllItems);
        this.addProperty(contextDef.attributes, "AllowPublicStudentCreation", "Allow Public Student Creation", DwAttributeType.YesNo, DwControlType.Checkbox);
        this.addProperty(contextDef.attributes, "PublicPortalIsActive", "Public Portal Is Active", DwAttributeType.YesNo, DwControlType.Checkbox);
        this.addProperty(contextDef.attributes, "PublicPortalSlug", "Public Portal Slug", DwAttributeType.Text, DwControlType.Textbox);
        this.addProperty(contextDef.attributes, "ValidateExaminerTrainingForPOA", "Validate Examiner Training For POA", DwAttributeType.YesNo, DwControlType.Checkbox);
        
        this.addProperty(contextDef.attributes, "SchoolFeatures", "School Features", DwAttributeType.Integer, DwControlType.DropDownList, AppMetaDataLookups.SchoolFeatureAllItems);
    }

    getCustomContext(context: any): any {
        return this.schoolRepositoryService.getSchoolFeatures()
            .pipe(tap(features => {
                
            }));
    }
}

